import { HttpCustomPackageList, HttpDeleteCustomPackage } from '@/service/tasks';
import TableList from "@components/templates/tablelist";
import comIndex from './update'
import { mapGetters } from 'vuex';
import mixin from '../mixin';
export default {
    mixins: [TableList, mixin],
    components: {
        comIndex
    },
    data() {
        return {
            isMixin: true,
            Tools: { show: true },
            formData: {},
            exportData:{},
            Searchs: {
                show: true,
                labelWidth: 90,
            },
            Plugins: { show: true },
        };
    },
    methods: {
        ajaxRequest: HttpCustomPackageList,
        interceptRequest(params) {
            const { IN_orgWarehouseCode, BT_packageDate } = params.search;
            params.orgWarehouseCode = IN_orgWarehouseCode;
            params.search.LE_packStartAt = BT_packageDate ? BT_packageDate.split('~')[0] : '';
            params.search.GE_packEndAt = BT_packageDate ? BT_packageDate.split('~')[1] : '';
            delete params.search.IN_orgWarehouseCode;
            delete params.search.BT_packageDate;
            delete params.search.undefined;
            this.exportData = params;
            return params;
        },
        handleOperates(params = "", type, batch) {
            switch (type) {
                case 'add':
                    this.operate = {
                        title: '添加配置',
                        show: true,
                        width: 800,
                        querytype: 'add',
                        component: "comIndex",
                        showFooter: false,
                    }
                    break;
                case "edit":
                    this.operate = {
                        title: this.$t('global.common.edit', { defaultValue: '编辑' }),
                        show: true,
                        width: 'middle',
                        component: "comIndex",
                        activeids: params,
                        querytype: 'edit',
                        showFooter: false
                    }
                    break;
                case "delete":
                    this.operate = {
                        show: true,
                        alert: 'warning',
                        params: { id: params },
                        title: this.$t('global.common.delete', { defaultValue: '删除' }),
                        ajaxRequest: HttpDeleteCustomPackage,
                        desc: this.$t('fbb.localemanage.confirm_delete', { defaultValue: '删除后不可恢复，是否确认删除？' }),
                    }
                    break;
                case 'export':
                    this.handleWebfs(
                        process.env.VUE_APP_APIURL_FBB + "/api/v2/newBilling/packConfigCustomer/batchExport", this.exportData,
                        { executor: 'request', download: true }
                    );
                    break;
            }
        },
        getOperateNodeMap(row) {
            const { id } = row
            return [
                // {
                //     label: this.$t('global.common.query', { defaultValue: '查看' }),
                //     show: true,
                //     params: id,
                //     operate: 'query'
                // },
                {
                    label: this.$t('global.common.edit', { defaultValue: '编辑' }),
                    show: true,
                    params: id,
                    operate: 'edit'
                },
                {
                    label: this.$t('global.common.delete', { defaultValue: '删除' }),
                    show: true,
                    params: id,
                    operate: 'delete'
                }
            ]
        },
    },
    computed: {
        ...mapGetters('dictionary', ['getBillcusorgList', 'getAdminTransferWarehouse']),
        ToolsData() {
            return [
                {
                    name: "添加",
                    operate: "add",
                    theme: "primary",
                },
                {
                    name: "导出",
                    operate: "export",
                },
            ]
        },
        SearchsData() {
            return [
                // {
                //     label: this.$t('fbb.alloment.client_organization', { defaultValue: '客户' }),
                //     key: 'EQ_orgId',
                //     tag: 'Select',
                //     options: this.getBillcusorgList,
                //     props: {
                //         filterable: true,
                //     },
                //     show: true,
                //     style: "width:250px",
                // },
                {
                    label: this.$t('fbb.alloment.client_organization', { defaultValue: '客户' }),
                    tag: 'div',
                    show:true,
                    children:(h)=>{
                        return h("compMultipleSelect",{
                            props: {
                                options:this.getBillcusorgList,
                                modelValue:this.formData.search.IN_orgId,
                                placeholder:this.$t('fbb.alloment.client_organization', { defaultValue: '客户' }),
                                // isShowCheckAll:false,//是否展示全选按钮
                            },
                            on:{
                                'update:modelValue':(val)=>{
                                    this.formData.search.IN_orgId = val
                                }
                            }
                        })
                    },
                    style: "width:250px",
                },
                // {
                //     label: this.$t('erp.b2c.product_orgwarehouse', { defaultValue: "仓库" }),
                //     key: 'IN_orgWarehouseCode',
                //     tag: 'Select',
                //     options: this.getAdminTransferWarehouse ,
                //     props: {
                //         filterable: true,
                //     },
                //     show: true,
                //     style: "width:250px",
                // },
                {
                    label: this.$t('erp.b2c.product_orgwarehouse', { defaultValue: "仓库" }),
                    tag: 'div',
                    show:true,
                    children:(h)=>{
                        return h("compMultipleSelect",{
                            props: {
                                options:this.getAdminTransferWarehouse,
                                modelValue:this.formData.search.IN_orgWarehouseCode,
                                placeholder:this.$t('erp.b2c.product_orgwarehouse', { defaultValue: "仓库" }),
                                // isShowCheckAll:false,//是否展示全选按钮
                            },
                            on:{
                                'update:modelValue':(val)=>{
                                    this.formData.search.IN_orgWarehouseCode = val
                                }
                            }
                        })
                    },
                    style: "width:250px",
                },
                {
                    label: "包仓日期",
                    tag: 'vDatepicker',
                    key: 'BT_packageDate',
                    props: {
                        options: this.options,
                        format: 'yyyy-mm-dd ~ yyyy-mm-dd',
                        confirm: false,
                    },
                    show: true,
                    style: "width:250px",
                },
            ]
        },
        columns() {
            return [
                {
                    type: "index",
                    title: "No.",
                    width: 60,
                    align: "center",
                },
                {
                    title: '操作',
                    width: 80,
                    render: this.getOperateNodes
                },
                {
                    title: this.$t('fbb.alloment.client_organization', { defaultValue: '客户' }),
                    key: 'orgId',
                    render: (h, { row }) => {
                        const org = this.getBillcusorgList.filter( item=> item.value === row.orgId)[0] || {};
                        return <div>{org.label || '--'}</div>
                    }
                },
                {
                    title: "包仓仓库",
                    render: (h, { row }) => {
                        const wareHouse = [];
                        let packWarehouse = row.packItemCustomerEntities;
                        packWarehouse.forEach(item=>{
                            let orgWarehouseCode = item.orgWarehouseCode
                            const { label } = this.getAdminTransferWarehouse.find(function (item) { return item.attach.code == orgWarehouseCode}) || {};
                            wareHouse.push(<div>{label}</div>)
                        })
                        return wareHouse
                    }
                },
                {
                    title: "包仓总体积（CBM）",
                    key: 'volume',
                },
                {
                    title: "包仓日期",
                    render: (h, { row }) => {
                        return <div>{row.packStartAt || '--'}~{row.packEndAt || '--'}</div>
                    }
                },
                {
                    title: "更新时间",
                    key: 'updatedAt',
                }];
        },
    },
};




